import Amplify, { Auth, Hub } from 'aws-amplify'

export default {
  state: {
    provider: null,
    user: null,
    error: null
  },
  getters: {
    authError: state => state.error,
    isAuthenticated: state => Boolean(state.user),
    loggedUser: state => state.user,
    loggedUserId: (state, getters) =>
      getters.loggedUser && getters.loggedUser.attributes ? getters.loggedUser.attributes.sub : null,
    loggedUsername: (state, getters) => (getters.loggedUser ? getters.loggedUser.username : ''),
    loggedUserRole: (state, getters) =>
      getters.loggedUser && getters.loggedUser.attributes ? getters.loggedUser.attributes.profile : 'default',
    loggedUserFullName: (state, getters) => {
      const username = getters.loggedUsername
      const fullname = []
      if (getters.loggedUser && getters.loggedUser.attributes && getters.loggedUser.attributes.given_name) {
        fullname.push(getters.loggedUser.attributes.given_name)
      }
      if (getters.loggedUser && getters.loggedUser.attributes && getters.loggedUser.attributes.family_name) {
        fullname.push(getters.loggedUser.attributes.family_name)
      }
      return fullname ? fullname.join(' ') : username || getters.loggedUserId
    }
  },
  mutations: {
    AUTH_SET_PROVIDER(state, provider) {
      state.provider = provider
    },
    AUTH_SET_USER(state, user) {
      state.user = user
    },
    AUTH_SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    AUTH_INIT({ commit, state }, config) {
      if (!state.provider) {
        commit('AUTH_SET_PROVIDER', Amplify.configure({ Auth: config }))
        Hub.listen('auth', data => {
          switch (data.payload.event) {
            case 'signOut':
              window.location.reload()
              break
          }
        })
      }
    },
    AUTH_IS_LOGGED_IN({ commit, dispatch }) {
      return new Promise(resolve => {
        Auth.currentUserInfo().then(user => {
          if (user === null) {
            resolve(null)
          } else if (typeof user === 'object' && Object.keys(user).length === 0) {
            dispatch('AUTH_LOGOUT')
          } else {
            commit('AUTH_SET_USER', user)
            resolve(user)
          }
        })
      })
    },
    AUTH_LOGOUT() {
      //TODO: check promise....
      Auth.signOut()
    },
    AUTH_LOGIN({ dispatch, commit }, params) {
      return new Promise(resolve => {
        dispatch('APP_IS_FETCHING')
        Auth.signIn(params.username, params.password)
          .then(user => {
            dispatch('APP_IS_FETCHING', false)
            if (user.challengeName) {
              switch (user.challengeName) {
                case 'NEW_PASSWORD_REQUIRED':
                  resolve(user)
                  break
                default:
                  commit('AUTH_SET_ERROR', `Challenge ${user.challengeName} not managed`)
                  resolve(false)
                  break
              }
            } else {
              commit('AUTH_SET_USER', user)
              resolve(user)
            }
          })
          .catch(err => {
            dispatch('APP_IS_FETCHING', false)
            commit('AUTH_SET_ERROR', err)
            resolve(false)
          })
      })
    },
    AUTH_CHANGE_PASSWORD({ dispatch, commit }, params) {
      return new Promise(resolve => {
        dispatch('APP_IS_FETCHING')
        Auth.completeNewPassword(params.user, params.password)
          .then(user => {
            dispatch('APP_IS_FETCHING', false)
            commit('AUTH_SET_USER', user)
            resolve('AUTH_LOGIN_SUCCESS')
          })
          .catch(err => {
            dispatch('APP_IS_FETCHING', false)
            commit('AUTH_SET_ERROR', err)
            resolve(false)
          })
      })
    },
    RESET_AUTH_LOGIN_ERROR({ commit }) {
      commit('AUTH_SET_ERROR', false)
    }
  }
}
